'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapMarker = function (_Component) {
  (0, _inherits3.default)(MapMarker, _Component);

  function MapMarker() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MapMarker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MapMarker.__proto__ || (0, _getPrototypeOf2.default)(MapMarker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      popoverVisible: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MapMarker, [{
    key: 'setPopoverVisibility',
    value: function setPopoverVisibility(status) {
      this.setState({ popoverVisible: status });
    }
  }, {
    key: 'showPopover',
    value: function showPopover() {
      if (!this.state.popoverVisible) {
        this.setPopoverVisibility(true);
      }
    }
  }, {
    key: 'hidePopover',
    value: function hidePopover() {
      if (this.state.popoverVisible) {
        this.setPopoverVisibility(false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.id || this.props.events // eslint-disable-line react/prop-types
      ? _react2.default.createElement(
        'span',
        {
          onMouseEnter: this.showPopover.bind(this),
          onMouseLeave: this.hidePopover.bind(this),
          onClick: this.showPopover.bind(this),
          className: 'MapMarker interactive'
        },
        _react2.default.createElement(
          _.Popover,
          {
            visible: this.state.popoverVisible,
            clickOverlay: this.hidePopover.bind(this),
            width: 200,
            dropdownView: this.props.events ? _react2.default.createElement(_.EventList, { events: this.props.events, layout: 'grid', size: 'small', groupBy: 'none', columns: 1 }) : _react2.default.createElement(_.EventListItem, { layout: 'grid', size: 'small', event: this.props })
          },
          _react2.default.createElement(_.Icon, { name: 'pin' })
        )
      ) : _react2.default.createElement(
        'span',
        { className: 'MapMarker' },
        _react2.default.createElement(_.Icon, { name: 'pin' })
      );
    }
  }]);
  return MapMarker;
}(_react.Component);

MapMarker.propTypes = {
  /**
   * Optional array to display more than one event at a time
   */
  events: _propTypes2.default.array
};
MapMarker.defaultProps = {
  hasPopover: true
};
exports.default = MapMarker;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/MapMarker.js
// module id = 279
// module chunks = 0